<div class="Txt-Deposit">
  <h2>{{ 'Deposit' | t }}</h2>
  <span>{{ 'desc_deposit_paydox' | t }}</span>
</div>

<form class="example-form" [formGroup]="creditcardDatas">
  <mat-form-field style="width: 100%">
    <input matInput required placeholder="{{ 'Amount' | t }}" type="number" formControlName="amount" />
  </mat-form-field>
</form>
<button mat-raised-button class="form-submit-button" (click)="submitCreditCardData()" [disabled]="!creditcardDatas.valid">{{ 'Pay' | t }}</button>
